import React, { useEffect } from 'react';
import { Film, History } from 'lucide-react';

function getStatusClasses(status) {
  if (status === 'complete') {
    return 'border-emerald-500/30 bg-emerald-500/10 text-emerald-300';
  }

  if (status === 'error') {
    return 'border-red-500/30 bg-red-500/10 text-red-300';
  }

  return 'border-[#E8B800]/30 bg-[#E8B800]/10 text-[#E8B800]';
}

export default function GameHistory({ games, onSelectGame, activeGameId }) {
  useEffect(() => {
    console.log('[DropZone:History] render update', {
      count: games?.length || 0,
      activeGameId,
    });
  }, [games, activeGameId]);

  if (!games?.length) {
    return (
      <div className="flex h-full flex-col items-center justify-center rounded-3xl border border-dashed border-[#1A1A1A] bg-[#0A0A0A] p-6 text-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-full border border-[#1A1A1A] bg-[#111111] text-zinc-500">
          <History size={28} />
        </div>
        <div className="mt-4 text-lg font-semibold text-white">No games yet</div>
        <div className="mt-2 max-w-xs text-sm leading-6 text-zinc-500">
          Uploaded and analyzed games will appear here for quick re-entry into the six-lens results.
        </div>
      </div>
    );
  }

  return (
    <div className="h-full overflow-y-auto">
      <div className="space-y-3">
        {games.map((game) => {
          const gameId = game.jobId || game.id;
          const isActive = gameId === activeGameId;

          return (
            <button
              key={gameId}
              type="button"
              onClick={() => {
                console.log('[DropZone:History] select game', {
                  gameId,
                  status: game.status,
                });
                onSelectGame(game);
              }}
              className={[
                'w-full rounded-2xl border p-4 text-left transition-all duration-200',
                isActive
                  ? 'border-[#E8B800] bg-[#111111] shadow-[0_0_28px_rgba(232,184,0,0.12)]'
                  : 'border-[#1A1A1A] bg-[#0A0A0A] hover:border-zinc-700 hover:bg-[#111111]',
              ].join(' ')}
            >
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                  <div className="flex items-center gap-2">
                    <Film size={15} className="text-[#E8B800]" />
                    <div className="truncate text-sm font-semibold text-white">
                      {game.gameName || 'Untitled Game'}
                    </div>
                  </div>
                  <div className="mt-2 text-xs uppercase tracking-[0.18em] text-zinc-500">
                    {game.gameDate || 'Date pending'}
                  </div>
                </div>
                <div className={`rounded-full border px-3 py-1 text-[11px] font-medium uppercase tracking-[0.14em] ${getStatusClasses(game.status)}`}>
                  {game.status || 'submitted'}
                </div>
              </div>

              <div className="mt-4 text-sm text-zinc-400">
                {game.homeTeam || 'Home'} vs {game.awayTeam || 'Away'}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
